module.exports = __webpack_public_path__ + "bd8f6c411f3a09e5933f38c337d1b417.pdf";